import { useAppDispatch } from 'store/hooks';
import { setIsOffline } from 'store/reducer/general/slice';
import { useWindowEventListener } from 'hooks/useWindowEventListener';
import { DomEventType } from 'enums';

/**
 * Keeps the global `isOffline` flag in sync with the browser's online/offline
 * events. Mounted once at app boot; the shared refresh affordance reads the
 * flag to show the "you are offline" state and auto-hide when back online.
 */
export const useOnlineStatus = (): void => {
  const dispatch = useAppDispatch();

  useWindowEventListener(
    [DomEventType.ONLINE, DomEventType.OFFLINE],
    (event) => {
      dispatch(setIsOffline(event.type === DomEventType.OFFLINE));
    },
    [dispatch]
  );
};